<template>
  <div>
    <transition name="fade" appear>
      <main class="login">
        <section class="login__wrapper">
          <div class="login__left">
            <img
              class="login__image"
              alt="login image"
              src="@/assets/images/login/forgot-password.svg"
            />
          </div>
          <div class="login__right">
            <nav>
              <a href="/">
                <img
                  class="login__logo"
                  src="@/assets/images/brand/logo_full.svg"
                  alt="Early Stage Online"
                />
              </a>
            </nav>
            <section class="login__form-wrapper">
              <div class="login__form" v-if="!success">
                <div class="login__form-heading">
                  <h1 class="text-heading-m text-color-grey-900">Odzyskiwanie dostępu</h1>
                  <p class="text-body-long text-color-grey-700">
                    Nie pamiętasz hasła? Nie martw się! Wprowadź swój adres e-mail, a wyślemy Ci
                    wiadomość z instrukcją, jak je zmienić.
                  </p>
                </div>
                <form @submit.prevent="request" class="w-full">
                  <div class="w-full login__form-content">
                    <BaseInput
                      class="w-full"
                      type="text"
                      inputmode="email"
                      v-model="email"
                      autocomplete="email"
                      :applyErrorStyle="isError"
                      :noMargin="true"
                    >
                      Adres email
                    </BaseInput>
                    <div v-if="isError" class="login__form-error">
                      <span class="error-wrapper text-color-error-700">
                        <img
                          class="information-icon"
                          src="@/assets/images/icons/i_error.svg"
                          alt="error"
                        />
                        {{ errorText }}
                      </span>
                    </div>
                    <button type="submit" class="esc-button">
                      Przypomnij hasło
                    </button>
                  </div>
                </form>
              </div>
              <section class="login__success" v-if="success">
                <img alt="e-mail image" src="@/assets/images/login/forgot-mail.svg" />
                <div class="login__success-heading">
                  <h1 class="text-heading-m text-color-grey-900">
                    Wysłaliśmy Ci e-mail z linkiem do resetu hasła
                  </h1>
                  <p class="text-body-long text-color-grey-700">
                    Na podany adres e-mail w ciągu kilku minut powinna dotrzeć wiadomość z linkiem
                    do zresetowania hasła.
                  </p>
                </div>
                <div class="login__success-content">
                  <p class="text-body-strong"><strong>Nie widzisz e-maila?</strong></p>
                  <ul class="login__success-list text-color-grey-700">
                    <li class="text-body-long">
                      Sprawdź folder <strong>Spam</strong> lub <strong>Oferty</strong>, czasem
                      wiadomości tam trafiają.
                    </li>
                    <li class="text-body-long">
                      Jeśli nie otrzymasz e-maila w ciągu 15 minut, spróbuj ponownie.
                    </li>
                  </ul>
                </div>
              </section>
            </section>
            <footer class="login__footer">
              <a class="esc-link-tonal" :href="REGULATIONS_PATH" target="_blank">Regulamin</a>
              <a class="esc-link-tonal" href="/Polityka_Prywatności_ES_Online.pdf" target="_blank"
                >Polityka prywatności</a
              >
            </footer>
          </div>
        </section>
      </main>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseInput from '@/components/Form/BaseInput.vue';

export default {
  name: 'ForgotPasswordNew',
  components: {
    BaseInput,
  },

  props: {
    initialEmail: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      email: this.initialEmail || '',
      isError: false,
      errorText: '',
      isDisabled: false,
      success: false,
      hasLinkToLogin: false,
    };
  },

  computed: {
    ...mapState('layout', ['isLoading']),
  },

  created() {
    const { params } = this.$route;
    if (params?.hasLinkToLogin) {
      this.hasLinkToLogin = true;
    }
    this.$store.commit('layout/finishLoading');
  },

  methods: {
    ...mapActions('auth', ['requestNewPassword']),

    async request() {
      this.isDisabled = true;
      try {
        this.$store.commit('layout/startLoading');
        await this.requestNewPassword({ email: this.email });
        this.success = true;
      } catch (e) {
        this.isError = true;

        if (e.response && e.response.data) {
          this.errorText = e.response.data.errors.fields.email;
        } else {
          this.errorText = this.$t('auth.new_password_error');
        }
      } finally {
        this.isDisabled = false;
        this.$store.commit('layout/finishLoading');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.login {
  padding: 24px;
  padding-top: 40px;
  min-height: 100dvh;
  display: flex;

  @media screen and (min-width: 768px) {
    padding: 40px;
  }

  @media screen and (min-width: 1024px) {
    padding: 24px;
  }

  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 768px) {
    }

    @media screen and (min-width: 1024px) {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }
  }

  &__left {
    border-radius: 24px;
    background: #e8f4ff;
    display: none;
    padding: 24px;
    justify-content: center;
    align-items: center;
    height: 100%;

    @media screen and (min-width: 768px) {
    }

    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    height: 100%;
    width: 100%;
  }

  &__image {
    max-width: 610px;
    max-height: 610px;
    width: 100%;
    height: 100%;
  }

  &__form-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;

    @media screen and (min-width: 768px) {
      min-height: 480px;
    }
  }

  &__success {
    display: flex;
    width: 100%;
    max-width: 480px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;

    &-content {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &-heading {
      display: flex;
      gap: 8px;
      flex-direction: column;
    }

    &-list {
      list-style: unset;
      list-style-position: inside;
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-left: 4px;
    }
  }

  &__form {
    display: flex;
    width: 100%;
    max-width: 480px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;

    &-content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &-heading {
      display: flex;
      gap: 8px;
      flex-direction: column;
    }

    &-error {
      display: flex;
      align-items: center;
      margin-top: -16px;
    }
  }

  &__logo {
    width: 140px;
    height: 38px;
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 24px;

    @media screen and (min-width: 768px) {
    }

    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }
}
</style>
